export default {
  form: {
    font_family: {
      label: 'Familie de fonturi',
    },
    header: {
      label: 'Titlu',
      placeholder: 'Titlu',
    },
    sub_header: {
      label: 'Subtitlu',
      placeholder: 'Subtitlu',
    },
    footer: {
      label: 'Text subsol',
      placeholder: 'Introdu textul subsolului',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Selectează URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Culoare primară',
    },
    background_color: {
      label: 'Culoare fundal',
    },
    cover_image: {
      label: 'Imagine copertă',
    },
    logo: {
      label: 'Logo',
    },
    logo_zoom: {
      label: 'Zoom logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea autocolantului de ușă',
  },
};
